<template>
    <BaseModal
        v-model:open="open"
        data-qa="modal edit cv"
        contains-iframe
        :panel-classes="isMobile ? 'px-l' : ''"
        @after-leave="application.renderCv"
    >
        <template #headline>
            Lebenslauf bearbeiten
        </template>
        <template #default>
            <iframe
                data-qa="iframe"
                class="w-full h-[calc(100%-3.5rem)]"
                sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                :src="iframeSource"
                title="Lebenslauf bearbeiten"
            />
        </template>
    </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '../../headless/BaseModal.vue';
import { useApplicationStore } from '../../../stores/application-store';
import { useBreakpoints } from '../../../composables/breakpoint';

const { isMobile } = useBreakpoints();

const open = defineModel('open', { type: Boolean });

const iframeSource = ref(`${import.meta.env.VITE_KARL_URL}/lebenslauf/`);

const application = useApplicationStore();
</script>
